import {Fragment} from 'react';

export const nl2br = (str: string) =>
  str
    .trim()
    .split(/<br>|<br\/>|\r\n|\r|\n|\\n/)
    .map((item, key) => (
      <Fragment key={key}>
        {key > 0 && <br />}
        {item}
      </Fragment>
    ));
